export default __webpack_public_path__ + "static/media/gallery_11.cb17a726.jpg";